import React, { useState } from 'react';
import clsx from 'clsx';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { ActionDotsBlack } from '../../icons';
import { Dialog, DialogContent, DialogTrigger } from '../ui/Modal';
import { ConfirmationDialog } from '../ui';

const ActionItems = ({
  firstName,
  lastName,
  carName,
  handleClickAction,
  openFirstModal,
  openSecondModal,
  openThirdModal,
  setOpenFirstModal,
  setOpenSecondModal,
  setOpenThirdModal,
  isLoading,
}) => {
  const [openPopover, setOpenPopover] = useState(false);

  return (
    <Popover
      open={openPopover}
      onOpenChange={(open) => {
        setOpenPopover(open);
      }}
    >
      <PopoverTrigger>
        <ActionDotsBlack
          className={
            openPopover
              ? 'bg-black stroke-white rounded-full'
              : 'stroke-black cursor-pointer'
          }
        />
      </PopoverTrigger>
      <PopoverContent>
        <ul className="flex flex-col gap-y-2.5 p-2.5">
          <li>
            <ActionButton
              title="Ορισμός ως κύριος οδηγός"
              isLoading={isLoading}
              content={
                <div className="flex flex-col gap-2 text-center">
                  {/* <h3>Ορισμός ως κύριος οδηγός</h3> */}
                  <p className='text-body'>
                    Είσαι σίγουρος ότι θέλεις να ορίσεις τον/την
                      <b> {firstName} </b>
                    <b>{lastName}</b> ως κύριο οδηγό του αυτοκινήτου {carName};
                    </p>
                </div>
              }
              openModal={openFirstModal}
              setOpenModal={setOpenFirstModal}
              handleOkClick={() => handleClickAction('setPrimaryDriver')}
            />
          </li>
          <li>
            <ActionButton
              title="Αφαίρεση οδηγού"
              isLoading={isLoading}
              content={
                <div className="flex flex-col gap-2 text-center">
                  {/* <h3>Αφαίρεση οδηγού</h3> */}
                  <p className='text-body'>
                    Είσαι σίγουρος ότι θέλεις να αφαιρέσεις τον/την
                    <b> {firstName} </b>
                    <b>{lastName} </b>
                    από οδηγό του αυτοκινήτου {carName};
                    </p>
                </div>
              }
              openModal={openSecondModal}
              setOpenModal={setOpenSecondModal}
              handleOkClick={() => handleClickAction('unAssignDriver')}
            />
          </li>
          <li>
            <ActionButton
              className={'text-primary'}
              title={"Διαγραφή οδηγού"}
              isLoading={isLoading}
              content={
                <div className="flex flex-col gap-2 text-center">
                  {/* <h3>Διαγραφή οδηγού</h3> */}
                  <p className='text-body text-center'>
                    Είσαι σίγουρος ότι θέλεις να διαγράψεις οριστικά τον/την
                    <b> {firstName} </b><b>{lastName}</b> από τη συνολική λίστα οδηγών;
                    </p>
                </div>
              }
              openModal={openThirdModal}
              setOpenModal={setOpenThirdModal}
              handleOkClick={() => handleClickAction('deleteDriver')}
            />
          </li>
        </ul>
      </PopoverContent>
    </Popover>
  );
};

const ActionButton = ({
  title,
  content,
  className,
  openModal,
  setOpenModal,
  handleOkClick,
  isLoading,
}) => {
  return (
    <Dialog open={openModal} onOpenChange={(open) => setOpenModal(open)}>
      <DialogTrigger className={clsx('body-text', className)}>
          {title}
      </DialogTrigger>
      <DialogContent>
        <ConfirmationDialog
          title={title}
          isLoading={isLoading}
          message={content}
          handleOkClick={handleOkClick}
          handleCancelClick={() => setOpenModal(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ActionItems;
